<template>
  <div class="contents fd">
    <!-- 搜索弹框 -->
    <el-dialog v-dialogDrag :visible.sync="vis"
               :title="$t('getapi[978]')"
               width="80%"
               :close-on-click-modal="false">
      <div>
        <table>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[463]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Order_No"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2177]')}}</td>
            <td style="width:120px">
              <el-select filterable popper-class="select-option"
                         v-model="Head.issue_type_ID"
                         size="mini">
                <el-option v-for="item in ArrayIssueType" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
              </el-select>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[552]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Order_statusString"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1862]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Finance_StatusString"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
          </tr>


          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[1419]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.keep_account_person"  disabled popper-class="select-option"
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1420]')}}</td>
            <td style="width:120px;">
              <!-- <el-date-picker v-model="Head.keep_account_time" type="date" placeholder="选择日期"></el-date-picker> -->
              <el-date-picker
                    v-model="Head.keep_account_time"
										popper-class="select-option"
										type="date"
										value-format="yyyy-MM-dd"
										:placeholder="$t('getapi[6428]')"
										size="mini"
									></el-date-picker>
              
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2204]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.issue_person"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1857]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Finance_Date"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
          </tr>

          
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[2179]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.issue_time"  disabled
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[4469]')}}</td>
            <td style="width:120px;">
              <el-select filterable popper-class="select-option"
                         v-model="Head.Issue_Dept"
                         size="mini">
                <el-option v-for="item in DeptList" 
                           :key="item.Code"
                           :label="item.Name"
                           :value="item.Name"></el-option>
              </el-select>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[4531]')}}</td>
            <td style="width:320px;">
              <el-input v-model="Head.remark"
                        type="text"
                        size="mini"></el-input>
            </td>
            <td style="width:80px" v-show="IsShowOldOrderNo"
                align="right">{{$t('getapi[2203]')}}</td>
            <td style="width:320px;" v-show="IsShowOldOrderNo">
              <el-input v-model="Head.Relation_Blue_Order_No"
                        type="text"
                        size="mini"></el-input>
            </td>
          </tr>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[4472]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Keep_Person"
                        type="text" @click.native.prevent="selectEmployee(1)"
                        size="mini"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[4470]')}}</td>
            <td style="width:120px;">
              <el-input v-model="Head.Regist_Person"
                        type="text" @click.native.prevent="selectEmployee(2)"
                        size="mini"></el-input>
            </td>
            <td style="width:80px;"></td>
            <td style="width:120px;">
            </td>
            <td style="width:80px" 
                class="alignment-right">
              {{$t('getapi[2096]')}}
              <el-checkbox v-model="Head.Negative_Flag" disabled></el-checkbox>
            </td>
          </tr>
        </table>
        <div>
          <el-button type="primary"
                     size="mini" @click="addline" :disabled="isBtnAddDisable"
                     >{{$t('getapi[6092]')}}</el-button>
          <el-button type="primary" :disabled="isBtnSaveDisable"
                     size="mini" @click="save">{{$t('getapi[937]')}}</el-button>
          <el-button type="primary"
                     size="mini" @click="execute"
                     :disabled="isBtnExecuteDisable">{{$t('getapi[2105]')}}</el-button>
          <el-button type="primary"
                     size="mini"  @click="gred"
                     v-show="isBtnNegative">{{$t('getapi[2107]')}}</el-button>
        </div>
      <el-tabs 
        type=""
        @tab-click="tabClick"
        style="margin-top: 5px">

        <el-tab-pane :label="$t('getapi[2189]')"
                     name="0">
          <el-table :data="dataSetMain"
                    v-loading="loading"
                    height="250"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    stripe
                    border
                    size="mini"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; margin-top:2px"
                    :header-cell-style="$limits.headerClass">
            <el-table-column 
                           :label="$t('getapi[6048]')"
                           width="60">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteline(scope)"
                         type="text"
                         size="small">{{
                                $t('getapi[40]') }}
              </el-button>
            </template>
          </el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="line_No"
                             :label="$t('getapi[1425]')"
                             ></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="Line_status_Name"
                             :label="$t('getapi[552]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="specification"
                             :label="$t('getapi[125]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_code"
                             :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_name"
                             :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_version"
                             :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="model"
                             :label="$t('getapi[124]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[1628]')">
            <template slot-scope="scope" >
            <el-input v-model="scope.row.plan_qty" ></el-input>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="MeasureUnit"
                             :label="$t('getapi[888]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="invqty"
                             :label="$t('getapi[2920]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')">
            <template slot-scope="scope" >
                  <el-input v-model="scope.row.customer_code" @click.native.prevent="showCustomPop(scope)"></el-input>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')">
            <template slot-scope="scope" >
            <el-input v-model="scope.row.item_code" @click.native.prevent="showProjectPop(scope)"></el-input>
            </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-row class="page">
          <el-col :span="18">
          <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[50, 100, 200, 300]"
                    :page-size="50"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalMain"></el-pagination>
          </el-col>
          <el-col :span="6">
          
          </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('getapi[2200]')"
                     name="1">
          <el-table :data="dataSetAssist"
                    v-loading="loading"
                    height="300"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    stripe
                    border
                    size="mini"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; margin-top:2px"
                    :header-cell-style="$limits.headerClass">
            <el-table-column 
                            :label="$t('getapi[6048]')"
                            width="60">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteline(scope)"
                          type="text"
                          size="small">{{
                                $t('getapi[40]') }}
              </el-button>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="line_No"
                             :label="$t('getapi[1425]')"
                             ></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="Line_status_Name"
                             :label="$t('getapi[552]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="specification"
                             :label="$t('getapi[4187]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_code"
                             :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_name"
                             :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="part_version"
                             :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="model"
                             :label="$t('getapi[124]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="plan_qty"
                             :label="$t('getapi[1628]')">
            <template slot-scope="scope" >
            <el-input v-model="scope.row.plan_qty" ></el-input>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="MeasureUnit"
                             :label="$t('getapi[888]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="Assist_plan_qty"
                             :label="$t('getapi[2201]')">
            <template slot-scope="scope" >
            <el-input v-model="scope.row.Assist_plan_qty" ></el-input>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="Assist_MeasureUnit"
                             :label="$t('getapi[130]')"></el-table-column>
            <el-table-column show-overflow-tooltip
                             prop="invqty"
                             :label="$t('getapi[2920]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')">
            <template slot-scope="scope" >
                  <el-input v-model="scope.row.customer_code" @click.native.prevent="showCustomPop(scope)"></el-input>
            </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')">
            <template slot-scope="scope" >
            <el-input v-model="scope.row.item_code" @click.native.prevent="showProjectPop(scope)"></el-input>
            </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-row class="page">
          <el-col :span="18">
          <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[50, 100, 200, 300]"
                    :page-size="50"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalAssist"></el-pagination>
          </el-col>
          <el-col :span="6">
          
          </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="vis = false">{{$t('getapi[6]')}}</el-button>
        <!-- <el-button type="primary" @click="confirm">{{$t('getapi[937]')}}</el-button> -->
        </span>
    </el-dialog>
    <!--供应商-->
    <!-- <order :isVisible="supplierVisible"
           @getsupplier="getsupplier"
           ref="supplier"></order> -->
  
    <!--选择保管员 输出，输入-->
    <employee :isVisible="KeeperVisible" @getemployee="getkeeper" ref="inputemp"></employee>
    <!--选择记账员 -->
    <employee :isVisible="AccounterVisible" @getemployee="getaccounter" ref="inputempp"></employee>
    <!--主计量物料选择 -->
    <OM :isVisible="materialsVisible" @addmaterials="callbackmaterial" ref="inputmaterialtype"></OM>
    <!--次计量物料选择 -->
    <!--客户代码 -->
    <customer :isVisible="isShowCustomer" @getcustomer="callbackcustomer" ref="inputcustomer"></customer>
    <!--项目代码 -->
    <itemCode :isVisible="isShowItem" @getproject="callbackproject" ref="inputitemcode"></itemCode>


  </div>
 
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
  name: 'InvOutManager',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isBtnAddDisable:false,
      isBtnExecuteDisable:true,
      isBtnSaveDisable:false,
      loading:false,
      materialsVisible:false,
      IsNew:false,//是否新增操作
      canmodifykeepaccounttime:false,//允许修改建单时间
      IsCreatingRed:false,//正在生成红单
      IsShowOldOrderNo:false,//是否显示原单号
      isBtnNegative:false,//是红单亮
      lineno:0,//当前最大行号
      NowCustomerIndex:0,//当前客户代码
      NowProjectIndex:0,//当前项目代码index
      isShowItem:false,
      isShowCustomer:false,//是否显示客户代码选项 下拉
      Head:{},
      IsMain:true,//主Tab页是否被选择
      KeeperVisible:false,
      AccounterVisible:false,
      vis: this.isVisible, // 是否显示弹窗，
      ArrayIssueType: [], // 出库类型
      DeptList:[],//领料部门
      // ArrayTransMode: [], // 运输方式
      supplierVisible: false,
      dataSetMain: [], // 主表数据
      dataSetAssist: [], //次主表数据
      totalMain:0,
      totalAssist:0,
      pageIndex: 1, // 当前页
      pageSize: 50, // 当前页数据量
      user:'',

    }
  },
  mounted: function () {
    let that = this
    that.vis = that.isVisible;
    let userData = JSON.parse(sessionStorage.getItem('userData'))
    that.user = userData['username'];
    that.ArrayIssueType = Array.methods.ArrayIssueType();
    that.DeptList = Array.methods.getIssueDeptList();
    // that.ArrayTransMode = Array.methods.getTransMode();
  },
  methods: {
    execute(){
      let that = this;
      that.$store.commit('setSharedParams',   {
          order_no:that.Head.Order_No,
          issue_type:that.Head.issue_type_Name
      });
      let item = {
				label: '通用出库执行',
				name: 'general',
				path: '/general/1',
				url: '/general/1',
				icon: 'video-play'
			};
			this.$router.push({ path: '/general/1'});
      this.$store.commit('selectMenu', item);
      that.vis = false;

    },
    showCustomPop(val) {
        let that = this;
        that.NowCustomerIndex = val.$index;
        that.isShowCustomer = true;
        that.$refs.inputcustomer.clearInput(this.isShowCustomer, false, 0);     },
    showProjectPop(val) {
        let that = this;
        that.NowProjectIndex = val.$index;
        that.isShowItem = true;
        that.$refs.inputitemcode.clearInput(this.isShowItem, false, 1);
    },
    gred(){
      let that = this;
      that.IsCreatingRed= true;
      that.IsShowOldOrderNo = true;
      let nowtime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString();
      that.Head.Negative_Flag = true;
      that.Head.Relation_Blue_Order_No = that.Head.Order_No;
      that.Head.Order_No='';
      that.Head.Order_status=0,
      that.Head.Order_statusString='生成';
      //that.Head.Finance_Status='',
      //that.Head.Finance_StatusString='';
      that.Head.keep_account_person='';
      that.Head.keep_account_time=nowtime;
      that.Head.issue_person='';
      that.Head.Finance_Date=nowtime;
      that.Head.issue_time=nowtime;
      that.Head.Issue_Dept='';
      that.Head.remark='';
      that.Head.Keep_Person='';
      that.Head.Regist_Person='';

      for(let i=0;i<that.dataSetMain.length;i++){
        that.dataSetMain[i].Exclusively_Id='';
        that.dataSetMain[i].Relation_Order_No='';
        that.dataSetMain[i].Line_status=0;
        that.dataSetMain[i].Line_status_Name="生成";
        that.dataSetMain[i].plan_qty = -that.dataSetMain[i].plan_qty;
      }
      for(let j=0;j<that.dataSetAssist.length;j++){
         that.dataSetAssist[j].Exclusively_Id='';
        that.dataSetAssist[j].Relation_Order_No='';
        that.dataSetAssist[j].Line_status=0;
        that.dataSetAssist[j].Line_status_Name="生成";
        that.dataSetAssist[j].plan_qty = -that.dataSetAssist[j].plan_qty;
        that.dataSetAssist[j].Assist_plan_qty = -that.dataSetAssist[j].Assist_plan_qty;
      }
      that.isBtnSaveDisable = false;
      

    },
    save() {
        let that = this;      
        let parm =  {
            head: that.Head,
            line: [],
            LangType: that.$processdata.getLang(),
        };
        if(that.Head.issue_type_ID==undefined){
          that.$message.warning(that.$t('getapi[8621]'));//'出库类型不能为空！'
          return;
        }
        if(that.Head.Keep_Person==''){
          that.$message.warning(that.$t('getapi[2886]'));//'保管员不能为空！'
          return;
        }
        if(that.Head.Regist_Person==''){
          that.$message.warning(that.$t('getapi[2887]'));//'记账员不能为空！'
          return;
        }
         if(that.Head.Issue_Dept==''){
          that.$message.warning(that.$t('getapi[4542]'));//'领料部门必须选择！'
          return;
        }
        
        for(let i=0;i<that.dataSetMain.length;i++){
          if(that.dataSetMain[i].customer_code==''){
            that.$message.warning(that.$t('getapi[2624]'));//'客户代码不能为空！'
            return ;
          }
          parm.line.push(that.dataSetMain[i]);
        }
        for(let j=0;j<that.dataSetAssist.length;j++){
          if(that.dataSetAssist[j].customer_code==''){
            that.$message.warning(that.$t('getapi[2624]'));//客户代码不能为空！
            return ;
          }
          parm.line.push(that.dataSetAssist[j]);
        }
        console.log(JSON.stringify(parm));
        that.$http.urlpost('/Inv/UniversalOut/InvIssueSave', parm, function (res) {
            console.log(res);
            if (res.Success == 1) {
              if(that.IsCreatingRed||that.IsNew){
                that.$message.success(that.$t('getapi[4103]'));//'新建成功！'
                let qdata={
                    IID :"",
                    Code: res.UniqueNum,
                    Name: "",
                    Status: ""
                  }
                that.IsNew = false;
                that.IsCreatingRed = false;
                that.getDetail(qdata);
                return;
              }else{
                 that.$message.success(that.$t('getapi[4105]'));//'修改成功！'
                 that.isShowEdit = false;
              }
            }
            that.vis= false;
        });
    },
    addline(){
      //弹框选择数据
      let that = this;
      that.materialsVisible = true;
      if(that.IsMain)that.$refs.inputmaterialtype.clearInput(that.materialsVisible, false, 7);
      else that.$refs.inputmaterialtype.clearInput(that.materialsVisible, false, 8);
    },
    callbackcustomer(data){
      let that = this;
      if(that.IsMain){
        that.dataSetMain[that.NowCustomerIndex].customer_code = data.customer_id;
      }else  that.dataSetAssist[that.NowCustomerIndex].customer_code = data.customer_id;
    },
    callbackproject(data){
      let that = this;
      if(that.IsMain){
        that.dataSetMain[that.NowProjectIndex].item_code = data.item_code;
      }else  that.dataSetAssist[that.NowProjectIndex].item_code = data.item_code;
    },
    //插入到表格中
    callbackmaterial(data){
      let that = this;
      that.lineno++;
      
        let tempm = {
          Exclusively_Id: 0,
          Relation_Order_No: that.Head.Order_No,
          line_No: that.lineno,
          Line_status: 0,
          Line_status_Name: "生成",
          part_code: data.part_code,
          part_name: data.part_name,
          part_version: data.part_version,
          mp_flag: data.mp_flag,
          model: data.part_model,
          specification: data.part_spec,
          plan_qty: 0,
          actually_qty: 0,
          MeasureUnit: data.part_master_unit,
          Assist_plan_qty: 0,
          Assist_actually_qty: 0,
          Assist_MeasureUnit: data.part_assist_unit,
          invqty: data.qty_on_hand,
          master_assist_rate: data.master_assist_rate,
          customer_code: "",
          item_code: ""
        }
      if(that.IsMain){
        that.dataSetMain.push(tempm);
      }else{
        that.dataSetAssist.push(tempm);
      }
      
    },
    //删除一行
    deleteline(row){
      let that = this;
      if(that.IsMain){
          that.dataSetMain.splice(row.$index,1);
      }else{
          that.dataSetAssist.splice(row.$index,1);
      }
    },
    tabClick(tab, event) {
      let that = this;
      if(tab.name==='0')that.IsMain = true;
      else that.IsMain = false;
    },
    handleSizeChange (val) {
      this.pageSize = val;
      
    },
    handleCurrentChange (val) {
      this.pageIndex = val;
    },
    handleSelectionChange(val) {
			let that = this;
			// that.selectIDData = '';
			// for (let i = 0; i < val.length; i++) {
			// 	that.selectIDData += val[i].cargoPosition_code + ',';
			// }
			// console.log(that.selectIDData);
    },

    clearInput (e, data) {
      let that = this
      that.vis = e;
      if (data.Code == '') {
        //reset data 新建
        let datetime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate());
        that.Head={
          Finance_Date:datetime,
          keep_account_time:datetime,
          Negative_Flag:false,
          IsCreatingRed:false,
          IsShowOldOrderNo: false,
          Order_No:'',
          Order_status:0,
          Order_statusString:'生成',
          Finance_Status:-1,
          issue_person:'',
          Issue_Dept:'',
          remark:'',
          Keep_Person:'',
          Regist_Person:'',
          keep_account_person:that.user,

        };
        that.dataSetMain=[];
        that.dataSetAssist=[];
        that.lineno=0;
        that.IsNew = true;
        that.isBtnAddDisable = false;
        that.isBtnSaveDisable = false;

      } else {
        that.getDetail(data);
      }
    },
    getDetail (data) {
      let that = this;
      that.IsShowOldOrderNo = false;
      that.dataSetMain = []; // 主表数据
      that.dataSetAssist= []; //次主表数据
      let parm = data;
      parm.LangType=that.$processdata.getLang()
      that.$http.urlpost('/Inv/UniversalOut/InvIssueDetail', parm, function (res) {
        if (res.Success == 1) {
          that.Head = res.DataContent.head[0];
          //关闭状态下 生成红单 亮
          if(that.Head.Order_statusString=='关闭')
          {
            that.isBtnNegative = true;//生成红单开启
            that.isBtnExecuteDisable = true;//执行关闭

            that.isBtnAddDisable = true;
            that.isBtnSaveDisable = true;
          }
          else 
          {
            that.isBtnNegative = false;//生成红单关闭
            that.isBtnExecuteDisable = false;//执行开启
            that.isBtnAddDisable = false;
            that.isBtnSaveDisable = false;
          }

          let allArray = res.DataContent.line;
          for(let i=0;i<allArray.length;i++ ){
              if(that.lineno<allArray[i].line_No)that.lineno = allArray[i].line_No;
              if(allArray[i].Assist_MeasureUnit===''){
                  that.dataSetMain.push(allArray[i]);

              }else{
                  that.dataSetAssist.push(allArray[i]);
              }
          }
          that.totalMain = that.dataSetMain.length;
           that.totalAssist = that.dataSetAssist.length;
        }
      });
    },
    selectSupplier () {
      let that = this;
      that.supplierVisible = true;
      that.$refs.supplier.clearInput(this.supplierVisible, false, 2);
    },
    getsupplier (data) {
      console.log(data)
    },
    //获取保管员后赋值
    getkeeper(data){
        let that = this;
        that.Head.Keep_Person = data.name;
    },
    //获取记账员后赋值
    getaccounter(data){
      let that = this;
      that.Head.Regist_Person = data.name;
    },
    selectEmployee(type){
      let that = this;
      if(type==1){
        that.KeeperVisible =true;
        this.$refs.inputemp.clearInput(that.KeeperVisible, false, 3);
      }else{
        that.AccounterVisible =true;
        this.$refs.inputempp.clearInput(that.AccounterVisible, false, 3);
      }

    },
  }
};
</script>

<style scoped lang="less">
.c-search-table {
    width: 100%;
    height: calc(~'100% - 10px'); /*这里我用了计算属性*/
}

.beauty-Scroll {
    .el-scrollbar {
        height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
    }
    .el-scrollbar__wrap {
        width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
        height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
    }
}
table {
  border-collapse: separate;
  border-spacing: 0px 5px;
  td {
    padding-left: 3px;
    white-space: pre;
  }
}
.el-input__inner {
  line-height: 28px;
  height: 28px;
}
.select-option {
	z-index: 9999 !important;
}
el-date-picker {
	width: 80%;
}
</style>
